import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MaterialModule } from "../material.module";

import { ReportsPageComponent } from "./pages/reports-page/reports-page.component";
import { ReportsRoutingModule } from "./reports-routing.module";
import { SesionDetailsComponent } from "./components/sesion-details/sesion-details.component";
import { SharedModule } from "../shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { DuplicateAttendeesTableComponent } from "./components/duplicate-attendees-table/duplicate-attendees-table.component";
import { DuplicateDetailByAttendantComponent } from "./components/duplicate-detail-by-attendant/duplicate-detail-by-attendant.component";
import { AttendancePartsDetailComponent } from "./components/attendance-parts-detail/attendance-parts-detail.component";
import { DuplicateAttendanceModalComponent } from "./components/duplicate-attendance-modal/duplicate-attendance-modal.component";
import { YearSessionSelectorComponent } from "./components/year-session-selector/year-session-selector.component";
import { AttendanceRecordModule } from "../attendanceRecord/attendanceRecord.module";

@NgModule({
  declarations: [
    ReportsPageComponent,
    SesionDetailsComponent,
    DuplicateAttendeesTableComponent,
    DuplicateDetailByAttendantComponent,
    AttendancePartsDetailComponent,
    DuplicateAttendanceModalComponent,
    YearSessionSelectorComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReportsRoutingModule,
    SharedModule,
    NgbModule,
    FormsModule,
    AttendanceRecordModule,
  ],
  exports: [ReportsPageComponent],
})
export class ReportsModule {}
